import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllTranslations } from "../../services/api/i18n";

const useTranslation = () => {
  const dispatch = useDispatch();
  const language = useSelector(state => state.i18n.lang);
  const translations = useSelector(state => state.i18n.translations);
  const translationsLoaded = useSelector(
    state => state.i18n.translationsLoaded
  );
  const loadingInitiated = useRef(false);

  useEffect(() => {
    if (!translationsLoaded && !loadingInitiated.current) {
      loadingInitiated.current = true;
      dispatch(loadAllTranslations(language)).catch(err => {
        console.error("Failed to load translations:", err);
        loadingInitiated.current = false;
      });
    }
  }, [dispatch, language, translationsLoaded]);

  const t = useCallback(
    id => {
      const translation = translations[id];
      if (translation) {
        return translation;
      }
      if (translationsLoaded) {
        console.warn(
          `Translation missing for key: ${id} (language: ${language})`
        );
      }
      return id;
    },
    [translations, language, translationsLoaded]
  );

  const isLoading = useCallback(() => {
    return !translationsLoaded;
  }, [translationsLoaded]);

  return { language, t, isLoading };
};

export default useTranslation;
